<template>
    <div class="container form-container p-4">
        <div class="text-3xl mb-4 pb-2 font-light flex items-end justify-between">
            <div data-cy="admin-settings-active-sessions-title">
                {{ $t('company.active_sessions.title') }}
            </div>
        </div>
        <active-session-table :association_id="association_id" ref="ActiveSessionsTable" />
    </div>
</template>

<script>
import ActiveSessionTable from '@/components/tables/ActiveSessions.vue';

export default {
    components: {
        ActiveSessionTable,
    },
    props: {
        association_id: {
            type: String,
            default: '',
        },
    },
    methods: {
        reload() {
            this.$refs.ActiveSessionsTable.reload();
        },
    },
};
</script>
